import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map } from 'rxjs/operators';
import { of } from 'rxjs';

import * as DvrSettingsActions from '../actions/dvr-settings.actions';
import { DvrSettingsService } from '../../vehicles/service/dvr-settings.service';
import { NotificationService } from '@fc-core/services/notification.service';
import { getErrorMessage } from '@fc-core/services/notification.utils';

@Injectable()
export class DvrSettingsEffects {
  loadCurrentDvrSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DvrSettingsActions.loadCurrentDvrSettings),
      concatMap(({ cameraId }) =>
        this.dvrSettingsService.getDvrSettingsById(cameraId).pipe(
          map((dvrSettings) =>
            DvrSettingsActions.loadCurrentDvrSettingsSuccess({ dvrSettings }),
          ),
          catchError((error) =>
            of(DvrSettingsActions.dvrSettingsFailure({ error })),
          ),
        ),
      ),
    );
  });

  loadDvrSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DvrSettingsActions.loadDvrSettings),
      concatMap(() =>
        this.dvrSettingsService.getDvrSettings().pipe(
          map((dvrSettings) =>
            DvrSettingsActions.loadDvrSettingsSuccess({ dvrSettings }),
          ),
          catchError((error) =>
            of(DvrSettingsActions.dvrSettingsFailure({ error })),
          ),
        ),
      ),
    );
  });
  updateManyDvrSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DvrSettingsActions.updateManyDvrSetting),
      concatMap(({ cameraSettingsList, cameraIds }) =>
        this.dvrSettingsService
          .updateManyCameraSettings(cameraSettingsList, cameraIds)
          .pipe(
            map(() => {
              this.notifications.showSuccess(
                'Camera settings successfully updated',
              );
              return DvrSettingsActions.updateManyDvrSettingSuccess({
                cameraSettingsList,
                cameraIds,
              });
            }),
            catchError((error) => {
              const errorMessage = getErrorMessage(error);
              this.notifications.showError(errorMessage);
              return of(DvrSettingsActions.dvrSettingsFailure({ error }));
            }),
          ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private notifications: NotificationService,
    private dvrSettingsService: DvrSettingsService,
  ) {}
}
